__turbopack_context__.v({
  "actionButton": "b7XtRG_actionButton",
  "actions": "b7XtRG_actions",
  "closeButton": "b7XtRG_closeButton",
  "content": "b7XtRG_content",
  "description": "b7XtRG_description",
  "dialog": "b7XtRG_dialog",
  "dialogActions": "b7XtRG_dialogActions",
  "dialogDescription": "b7XtRG_dialogDescription",
  "dialogSave": "b7XtRG_dialogSave",
  "dialogTitle": "b7XtRG_dialogTitle",
  "gpcNote": "b7XtRG_gpcNote",
  "heading": "b7XtRG_heading",
  "policyLink": "b7XtRG_policyLink",
  "primary": "b7XtRG_primary",
  "root": "b7XtRG_root",
  "switchControl": "b7XtRG_switchControl",
  "switchCopy": "b7XtRG_switchCopy",
  "switchDescription": "b7XtRG_switchDescription",
  "switchInput": "b7XtRG_switchInput",
  "switchInputLocked": "b7XtRG_switchInputLocked",
  "switchLabel": "b7XtRG_switchLabel",
  "switchList": "b7XtRG_switchList",
  "switchLock": "b7XtRG_switchLock",
  "switchRow": "b7XtRG_switchRow",
});
